var __isp_options = {
  isp_serp_callback: function () {
    $jquery_isp('.isp_grid_product').each(function () {
      var p_c, p = 0.00;
      var id = $jquery_isp(this).attr('product_id');
      var link_url = $jquery_isp(this).find('.isp_product_image_href').attr('href');
      if ($jquery_isp(this).find("span.isp_product_price.isp_compare_at_price_exist").length > 0) {
        p_c = parseFloat($jquery_isp(this).find("span.isp_product_price.isp_compare_at_price_exist")
          .text().replace("$", ""));
        p = parseFloat($jquery_isp(this).find(".isp_compare_at_price").text().replace(/[^\d.-]/g, ""));
      }
      if (ISP_PRODUCTS[id] && $jquery_isp(this).find(".product_discount_p").length == 0 && p_c > 0) {
        var discount = 100 - Math.round((p_c / p) * 100);
        $jquery_isp(this).find(".isp_product_image_wrapper .isp_product_image_href").after(
          '<div class="banner_holder"><span class="product_discount_p sale_banner">' + discount + '% OFF</span></div>');
      }

      if (link_url !== '') {
		var addToCartButton = $jquery_isp(this).find('.isp_product_add_to_cart_button');

		if (addToCartButton.length == 0) {
			$jquery_isp(this).find('.isp_product_desc').after('<a class="btn button isp_product_add_to_cart_button" title="product url" href="' + link_url + '">View Product</a>');
		}
		}
    });
  }
};
